import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Col, Row } from 'barnyard/layouts';
import { ColumnExportButton, Table } from 'barnyard/components';
import { format_dollars } from '~/app/common/utils';


const {
  CellRenderers: {
    renderNumber
  }
} = Table;

const SavingsTable = (props) => {
  const { view_type, savings, actions, includeExport, buyer_id } = props;
  const columns = [
    {
      Header: 'Name',
      id: 'name',
      accessor: view_type === 'ITEM' ? 'item_name' : 'buyer_name',
      Cell: ({ original }) => (
        view_type === 'ITEM' ? (
          <Link to={`/corporate/history/order/${original.order_id}`}>
            {original.item_name}
          </Link>
        ) : (
          <Link to={`/corporate/analyze/buyer/${original.buyer_id}`}>
            {original.buyer_name}
          </Link>
        )
      ),
      width: 400,
    }, {
      Header: 'Qty',
      accessor: 'quantity',
      width: 80,
      Cell: renderNumber,
    }, {
      Header: 'Price Paid',
      id: 'price_paid',
      accessor: row => (
        row.purchase_price ? (
          `${format_dollars({ integer: row.purchase_price, include_cents: true })} (${row.purchase_vendor})`
        ) : '-'
      )
    }, {
      Header: 'Best Hospital Price',
      id: 'best_hospital_price',
      accessor: (row) => {
        const value = row.lowest_buyer_price || row.purchase_price;
        return value ? (
          `${format_dollars(
            { integer: value, include_cents: true }
          )} (${row.lowest_buyer_vendor || row.purchase_vendor})`
        ) : '-';
      }
    }, {
      Header: 'Lowest Price From Supplier',
      id: 'lowest_vendor_price',
      accessor: row => (
        row.lowest_vendor_price ? (
          `${format_dollars(
            { integer: row.lowest_vendor_price, include_cents: true }
          )} (${row.lowest_vendor_buyer_name})`
        ) : '-'
      )
    }, {
      Header: 'Best Corporate Price',
      id: 'lowest_corporate_price',
      accessor: row => (row.lowest_corporate_price ? (
        `${format_dollars(
          { integer: row.lowest_corporate_price, include_cents: true }
        )} (${row.lowest_corporate_vendor})`
      ) : '-')
    }, {
      Header: 'Best Corporate Location',
      accessor: 'lowest_corporate_name',
    }, {
      Header: 'Net Loss',
      id: 'net_loss',
      accessor: row => (row.corporate_net_loss ? (
        `${format_dollars({ integer: row.corporate_net_loss, include_cents: true })}`
      ) : '-'),
      width: 130,
      className: 'u-right',
      headerClassName: 'u-right',
    }];

  const search = window.location.search;
  const query = !search || search === '?' ? '' : search

  return (
    <Table
      actions={
        <Row className='u-paddingTop10' gutter='sm'>
          <Col>{
            includeExport && (
              <ColumnExportButton
                className='u-paddingLeft10'
                columns={columns}
                data={savings}
                filename={`Vetcove_Missed_Savings_${buyer_id}${query}.csv`}
              >
                Download
              </ColumnExportButton>
            )
          }
          </Col>
          <Col>
            {actions}
          </Col>
        </Row>
      }
      size='small'
      NavigationBarComponent={() => null}
      pageSize={savings.length || 10}
      showPagination={false}
      columns={columns}
      data={savings}
    />
  );
};

SavingsTable.propTypes = {
  savings: PropTypes.arrayOf(PropTypes.shape({
    lowest_corporate_price: PropTypes.number,
    lowest_buyer_price: PropTypes.number,
    buyer_price: PropTypes.number,
    purchase_price: PropTypes.number,
    lowest_corporate_name: PropTypes.string,
    lowest_corporate_vendor: PropTypes.string,
    lowest_vendor_price_id: PropTypes.number,
    lowest_vendor_price: PropTypes.number,
    lowest_vendor_buyer_name: PropTypes.string,
    purchase_vendor: PropTypes.string,
    lowest_buyer_vendor: PropTypes.string,
  })).isRequired,
  view_type: PropTypes.oneOf(['BUYER', 'ITEM']),
  includeExport: PropTypes.bool,
  actions: PropTypes.object
};

SavingsTable.defaultProps = {
  view_type: 'ITEM',
  includeExport: false
};

export default SavingsTable;
